import { render, staticRenderFns } from "./Motherboard.vue?vue&type=template&id=21838637"
import script from "./Motherboard.vue?vue&type=script&lang=js"
export * from "./Motherboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21838637')) {
      api.createRecord('21838637', component.options)
    } else {
      api.reload('21838637', component.options)
    }
    module.hot.accept("./Motherboard.vue?vue&type=template&id=21838637", function () {
      api.rerender('21838637', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/templates/Motherboard.vue"
export default component.exports